module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"filter_by":"Filter by","active_filters":"Active Filters"},"es":{"filter_by":"Filtrar por","active_filters":"Filtros activos"}}')
  delete Component.options._Ctor
}
